
    // IMPORTS
    import { computed, defineComponent } from 'vue';
    import { usePortalMessageStore } from '@/store/portalMessages';

    import { StringUtil } from '@/util';
    import CloseButtonHeader from '@/components/common/close-button-header.vue'

    export default defineComponent({
        name: 'portalNotification',

        components: {
            CloseButtonHeader
        },

        setup() {
            /********************************************************************************************************************
             PRIVATE DATA
             ********************************************************************************************************************/
            const portalMessageStore = usePortalMessageStore()

            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const publicData = { }

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const portalNotification = computed(() => portalMessageStore.notification)
            const showPortalNotification = computed(() => StringUtil.hasContent(portalNotification.value))

            const portalWarning = computed(() => portalMessageStore.warning)
            const showPortalWarning = computed(() => StringUtil.hasContent(portalWarning.value))

            const showAnyMessage = computed(() => showPortalNotification.value || showPortalWarning.value)

            const computedData = {
                portalNotification,
                showPortalNotification,
                portalWarning,
                showPortalWarning,
                showAnyMessage
            }

            /********************************************************************************************************************
             PUBLIC METHODS AND EVENT HANDLERS
             ********************************************************************************************************************/
            function hideNotification() {
                portalMessageStore.hideNotification()
            }

            function hideWarning() {
                portalMessageStore.hideWarning()
            }

            const publicMethods = { hideNotification, hideWarning }
            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...publicData, ...computedData, ...publicMethods }
        }
    });
